import {IBasicParams, ICompanySyncstep} from "../../index";
import {global} from "../../appContext";
import {_} from 'lodash';
import {nsClone} from "../../clone/fn";
import PromiseRequest from "../../req/PromiseRequest";
import {SyncstepsWithCustomerKey} from "../../constants";
import {ICloneDialogOptions} from "../../clone/index";
import {IRequestObject} from "../../req/index";

export namespace nsSyncstep {
    export const SYNCSTEP_DELETE_SUCCESS : string = "syncstep.delete.success"

    export function create(syncstep: ICompanySyncstep, orgnr: string): Promise<ICompanySyncstep[]> {
        const cpy: ICompanySyncstep = _.cloneDeep(syncstep);
        cpy.id = 0;
        return new PromiseRequest("createcompanysyncstep")
            .request({
                companysyncstep: JSON.stringify(cpy),
                orgnr: orgnr
            })
            .then((data: ICompanySyncstep[]) => {
                global.cacheManager.removeCache('getruleset');
                global.cacheManager.removeCache('searchruleset');
                global.cacheManager.removeCache("getcompany");
                global.cacheManager.removeCache("getcompanysyncsteps");
                return data;
            });
    }

    export function find(syncstepId: number, orgnr: string): Promise<ICompanySyncstep> {
        return new PromiseRequest("getcompanysyncsteps")
            .request({orgnr: orgnr})
            .then((data: ICompanySyncstep[]): ICompanySyncstep => {
                const found = data.find((item: ICompanySyncstep) => item.syncstep.id == syncstepId);
                if (!found) {
                    throw new Error(`Syncstep ${syncstepId} not found`);
                }
                return found;
            });
    }

    const DialogOptions: ICloneDialogOptions = {icon: 'fa-syncstep', translationKey: 'synchronization step'};

    export function trash(companysyncstep: ICompanySyncstep): Promise<any> {
        return new PromiseRequest("deletecompanysyncstep")
            .request({companysyncstep: JSON.stringify(companysyncstep)})
            .then(() => {
                    global.cacheManager.removeCache('getruleset');
                    global.cacheManager.removeCache('searchruleset');
                    global.cacheManager.removeCache("getcompany");
                    global.cacheManager.removeCache("getcompanysyncsteps");
                }
            );
    }

    export function getAll(params?: IBasicParams): Promise<ICompanySyncstep[]> {
        return new PromiseRequest("getcompanysyncsteps").request(params);
    }

    export function getAll_reqObj(params?: IBasicParams): IRequestObject {
        const promise = new PromiseRequest("getcompanysyncsteps")
        const request = promise.request(params)
        return {promise, request}
    }

    export function syncstepConcernsCustomerKey(id: number): boolean {
        return SyncstepsWithCustomerKey.indexOf(id) != -1;
    }

}
